import {
  replaceSwatchPlaceholdersWithVariables,
  getSwatchPlaceholders,
} from '@packages/systems/style-legacy/swatches';
import type {RawStyleBlockType} from '@packages/systems/style-legacy/values';
import type {AnyVariableType} from '@packages/systems/core/utils/StyleVariables';
import {getAllVariablesIds} from '@packages/systems/core/utils/StyleVariables';

const migrateStyleBlockAndCollectIds = (
  styleBlock: RawStyleBlockType,
  variableMap: Map<string, AnyVariableType>
) => {
  const blockVariablesIds: string[] = [];
  const blockSwatchIds: string[] = [];

  const migrateLess = (styleLess: string) => {
    const newStyleLess = replaceSwatchPlaceholdersWithVariables(
      styleLess,
      variableMap
    );

    blockVariablesIds.push(...getAllVariablesIds(newStyleLess));
    blockSwatchIds.push(...getSwatchPlaceholders(newStyleLess));

    return newStyleLess;
  };

  const {styleLess, variants} = styleBlock;
  const migratedStyleBlock: RawStyleBlockType = styleLess
    ? {
        ...styleBlock,
        styleLess: migrateLess(styleLess),
      }
    : styleBlock;

  if (variants) {
    migratedStyleBlock.variants = {};
    for (const variantKey in variants) {
      const variant = variants[variantKey];

      if (variant) {
        migratedStyleBlock.variants[variantKey] = variant.styleLess
          ? {
              ...variant,
              styleLess: migrateLess(variant.styleLess),
            }
          : variant;
      }
    }
  }

  return {migratedStyleBlock, blockVariablesIds, blockSwatchIds};
};

export const migrateStyleBlocksToVariables = (
  styleBlocks: Array<RawStyleBlockType>,
  variableMap: Map<string, AnyVariableType>
) => {
  const migratedStyleBlocks: Array<RawStyleBlockType> = [];
  const variablesIds: string[] = [];
  const swatchIds: string[] = [];

  styleBlocks.forEach((styleBlock) => {
    const {migratedStyleBlock, blockVariablesIds, blockSwatchIds} =
      migrateStyleBlockAndCollectIds(styleBlock, variableMap);

    migratedStyleBlocks.push(migratedStyleBlock);
    variablesIds.push(...blockVariablesIds);
    swatchIds.push(...blockSwatchIds);
  });

  return {
    migratedStyleBlocks,
    variablesIds: new Set(variablesIds),
    swatchIds: new Set(swatchIds),
  };
};
